import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const globalSearchDialogK = {
  product: "global_search_dialog.product",
  project: "global_search_dialog.project",
  searchPlaceholder: "global_search_dialog.searchPlaceholder",
  projectLineItem: "global_search_dialog.projectLineItem",
  nothingFound: "global_search_dialog.nothingFound",
  customer: "global_search_dialog.customer",
};

export const useGlobalSearchDialogT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      product: t(globalSearchDialogK.product),
      project: t(globalSearchDialogK.project),
      searchPlaceholder: t(globalSearchDialogK.searchPlaceholder),
      projectLineItem: t(globalSearchDialogK.projectLineItem),
      nothingFound: t(globalSearchDialogK.nothingFound),
      customer: t(globalSearchDialogK.customer),
    }),
    [i18n.language]
  );
};